import React from 'react'
import { Phone } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import CopyToClipboard from '../../copy_to_clipboard'

class CallButton extends React.Component {

  render() {
    return (
      <Badge variant="secondary" size="md" className="h-8 rounded-full px-3" title="Call">
        <a key={this.props.mobile_number} href={`tel:${this.props.mobile_number}`}><Phone className="size-3.5"/></a> <CopyToClipboard content={this.props.mobile_number}>{this.props.mobile_number}</CopyToClipboard>
      </Badge>
    )
  }
}

export default CallButton
